import type { State } from 'state';
import type { LoginResponse } from 'state/actions/login';
import type { LoginUIState } from 'state/ui/login';
import type { DefaultError } from '@atlassian/help-center-common-util/errors';

const getLoginOrError = (state: State) => {
    return state.persisted.login;
};

export const getLogin = (state: State): LoginResponse | undefined => {
    const data = getLoginOrError(state);
    return data && 'login' in data && data.login ? data.login : undefined;
};

export const getLoginAnnouncementLocale = (state: State): string | undefined => {
    const data = getLoginOrError(state);
    return data && 'login' in data && data.login ? data.login?.loginAnnouncementLocale : undefined;
};

export const getIsLoginLoaded = (state: State): boolean => {
    const login = getLogin(state);
    return login !== undefined && login.redirectUrl !== undefined;
};

export const getLoginUIState = (state: State): LoginUIState => {
    return state.ui.login;
};

export const getLoginAttemptError = (state: State): DefaultError | undefined => {
    return getLoginUIState(state).error;
};

export const getIsFailedLoginAttempt = (state: State): boolean => {
    const loginUIState = getLoginUIState(state);
    return (
        getLoginAttemptError(state) !== undefined ||
        (loginUIState.loginAttemptResponse !== undefined && !loginUIState.loginAttemptResponse.loginSucceeded)
    );
};
